import lozsi from '../../resources/lozsi.jpg'
import slezakova from '../../resources/slezakova.jpg'
import simkovic from '../../resources/simkovic.png'

export default {
  title: 'Workshopy',
  presenter: 'workshops',
  text: `
Na workshopy se budete moci přihlásit samostatne mailem po přihlášení na konferenci. Cena jednoho workshopu je 250 CZK (10€). Kapacita workshopů je omezena.

![Lívia Lozsi](${lozsi})

## Lívia Lozsi - Rodina ako systém sociálnych vzťahov

### Ak človek ochorie vo vzťahoch, môže vo vzťahoch aj vyzdravieť

##### První patro, Salónek Modrý

Rodina ako primárny sociálny systém výrazne formuje psychický, fyzický, a sociálny rozvoj dieťaťa. To, ako sa k svojmu dieťaťu vzťahujeme, akú hodnotu mu prisudzujeme, významne ovplyvňuje jeho seba-vedomie. Vzťah rodiča k dieťaťu môže podporovať, ale takisto aj brzdiť rastový potenciál dieťaťa. Akými vplyvmi môžeme ako rodičia napáchať škody? Budeme hľadať spoločné odpovede na otázky, ktoré si kladie azda každý rodič.

Vyštudovala pedagogiku a andragogiku na Filozofickej fakulte UK v Bratislave. Po štúdiu krátko pracovala v materskej škole, neskôr ako vychovávateľka a sociálna pracovníčka v detskom domove v Seredi. Facilituje encounterové skupiny a výučbovo-tréningové programy pre širokú odbornú aj laickú verejnosť. Je aktívnou členkou Inštitútu psychoterapie a socioterapie, redaktorkou časopisu Socioterapia a psychoterapia, spoluatorkou knihy Socioterapia.
Zároveň je mamou dvoch detí.

![Petra Slezáková](${slezakova})

## Petra Slezáková - Život bez odpadu

##### První patro, Salónek Pavilon

Stále viac sa v médiách hovorí o klimatických zmenách a globálnych dopadoch nášho konzumného života. Planéta je zahltená plastovým odpadom a stopy ľudskej činnosti sú viditeľné aj na opustených ostrovoch v strede Tichého oceánu. Je naozaj toto planéta, ktorú chceme odovzdať našim deťom? Aký podiel na tom má každý z nás? Môže zodpovedná spotreba radikálne znížiť množstvo odpadu na svete? Ako môžeme našu domácnosť nastaviť na život (skoro) bez odpadu?
Na workshope sa dozviete konkrétne tipy a triky ako na to. Spolu sa naučíme šetriť nielen životné prostredie, ale aj naše zdravie a peňaženku.

Petra vyštudovala Ekonomickú Univerzitu v Bratislave a 14 rokov pracovala v bankovníctve na Slovensku i v zahraničí. Aktívne žije štýlom zero waste, čiže sa snaží neprodukovať žiaden odpad. Je zakladateľkou úspešného blogu Zero Waste Slovakia. O svojom životnom štýle prednáša na školách a pre širokú verejnosť. Motivuje ľudí k zodpovednosti za svoju spotrebu a životné prostredie.

![Juraj Šimkovič](${simkovic})

## Juraj Šimkovič - Školstvo potrebuje hravých hrdinov

### Môže byť učiteľ vzorom pre deti?

##### První patro, Salónek Merkur

Koľko času investujú pedagógovia do osobného tréningu a svojho zdravia? Veď predsa s nimi deti strávia v škole vo väčšine prípadov viac času ako so svojimi rodičmi. Deti samotné vedia prečo druhých nasledujú, či nenasledujú a prečo. Ako sa dajú využiť prvky z knihy Naivná pedagogika z praxe a spoločenskej hry Odvážni objavitelia pre budovanie pozitívnych vzťahov v škole? Akými možnosťami môžeme vytvárať komunitu nielen medzi deťmi a pedagógmi ale i rodičmi. Lebo šťastné vzťahy robia šťastné školstvo.

Sociálny pedagóg a vychovávateľ, v teréne s deťmi pôsobí od svojej mladosti, bol aktívnym skautom, animátorom, vychovávateľom, športovým manažérom. Aktuálne pôsobí v experimente „MANAŽÉR ŠŤASTIA“ v Súkromnej základnej škole v Novej Dubnici. V januári 2018 vyšla jeho knižná prvotina s názvom Naivná pedagogika z praxe: 15 rokov medzi „malými veľkými“ školiteľmi. Ak chceme meniť, formovať a vychovávať, musím najprv pracovať sám na sebe.
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/c03_workshops_sobota.js